import { RootState } from "integrations/redux"
import { createSlice } from "@reduxjs/toolkit"
import { Line } from "@nova/protobuf"
import { GeometryType } from "@nova/constants"
import { DeckGLGeometry } from "plugins/shared/layers/types"

type EditingData = {
    id: string
    mockedLine: DeckGLGeometry
}

type initialLineStateType = {
    editingData?: EditingData
}

export const MOCKED_LINE_ID = "MOCKED_LINE_ID"

const initialLineState: initialLineStateType = {}
const name = "line-v1"

const {
    reducer: lineReducer,
    actions: { moveLineToEditable, createNewMockLine, clearEditingData },
} = createSlice({
    name,
    initialState: {
        ...initialLineState,
    },
    reducers: {
        moveLineToEditable: (state, action: { payload: Line }) => {
            const editingData = {} as EditingData
            editingData.mockedLine = {
                ...action.payload,
                idx: 0,
            }
            editingData.id = action.payload.id
            state.editingData = editingData
        },
        createNewMockLine: (state) => {
            const editingData = {} as EditingData
            editingData.mockedLine = {
                id: MOCKED_LINE_ID,
                coordinates: [],
                geometryType: GeometryType.Line,
                idx: 0,
            }
            editingData.id = MOCKED_LINE_ID
            state.editingData = editingData
        },
        clearEditingData: () => {
            return { ...initialLineState }
        },
    },
})

const root = (s: RootState) => s[name]

export const selectLineEditingData = (s: RootState) => root(s).editingData

export { moveLineToEditable, createNewMockLine, clearEditingData }

export const reducer = { "line-v1": lineReducer }
